import { useEffect } from "react";
import { useRouter, useRouterState } from "@tanstack/react-router";

/** Mirror scope only after the destination has committed, using router state. */
export function useAdminScopeUrl(
  miembro: string | null,
  agencia: string | null,
  enabled: boolean,
) {
  const router = useRouter();
  const location = useRouterState({
    select: (state) =>
      state.status === "idle" && !state.isLoading ? state.location : null,
  });

  useEffect(() => {
    if (!enabled || !location) return;
    if (
      location.pathname !== "/admin" &&
      !location.pathname.startsWith("/admin/")
    )
      return;
    // A child effect or a click may already have started another navigation.
    if (
      router.state.status !== "idle" ||
      router.state.isLoading ||
      router.latestLocation.href !== location.href
    )
      return;
    const search = location.search as Record<string, unknown>;
    if (
      (search.miembro ?? null) === miembro &&
      (search.agencia ?? null) === agencia &&
      search.ambito === undefined
    )
      return;

    void router.navigate({
      to: location.pathname,
      search: (prev: Record<string, unknown>) => ({
        ...prev,
        miembro: miembro ?? undefined,
        agencia: agencia ?? undefined,
        ambito: undefined,
      }),
      hash: true,
      state: true,
      replace: true,
      resetScroll: false,
    });
  }, [router, location, miembro, agencia, enabled]);
}
